import PropTypes from 'prop-types';
import React, { useState, useMemo } from 'react';
import { connect } from 'react-redux';

import { addPageData, navigateWizard } from '../../actions';
import Button from '../../components/Button';
import InputField from '../../components/InputField';
import PageLayout from '../../components/PageLayout';
import analytics from '../../lib/analytics';
import * as payloadFactory from '../../lib/pageDataPayloadFactory';

const PassportNamePage = ({
  initialFirstName,
  initialLastName,
  dispatchAddPageData,
  dispatchWizardNav,
}) => {
  const [firstName, setFirstName] = useState(initialFirstName);
  const [lastName, setLastName] = useState(initialLastName);

  const removeSpacing = value => {
    return value.replace(/\s+/g, ' ');
  };

  const onFirstNameChanged = e => setFirstName(removeSpacing(e.target.value));
  const onLastNameChanged = e => setLastName(removeSpacing(e.target.value));

  const handleSubmit = e => {
    e.preventDefault();

    if (isInvalid) {
      return;
    }

    analytics.sendEvent('Click - Next', 'passport-name');

    const trimmedNames = {
      firstName: firstName.trim(),
      lastName: lastName.trim(),
    };

    const payload = payloadFactory.createAddPageDataPayload('passportName', trimmedNames);
    dispatchAddPageData(payload);
    dispatchWizardNav({ dir: 'fwd' });
  };

  const isInvalid = useMemo(() => {
    const regex = /^[a-zñáéíóúäëïöüçàèìòùßøåæþð ]{2,}(?:-[a-zñáéíóúäëïöüçàèìòùßøåæþð]{1,}| [a-zñáéíóúäëïöüçàèìòùßøåæþð]{2,})*$/i;

    if (!(firstName && lastName)) {
      return true;
    }

    if (!regex.test(firstName) || !regex.test(lastName)) {
      return true;
    }

    return false;
  }, [firstName, lastName]);

  const helpText =
    "Even if this name is different to your preferred name, we'll need it to make sure your contract is legally binding.\n\n" +
    "Don't have a passport yet? Just let us know the name that appears on your formal identity document.";

  return (
    <PageLayout title="What is the name on your passport?" helpText={helpText}>
      <form onSubmit={handleSubmit}>
        <div>
          <InputField
            type="text"
            label="First name"
            id="first-name"
            value={firstName}
            maxLength={200}
            onChange={onFirstNameChanged}
          />
        </div>

        <div className="mt-4">
          <InputField
            type="text"
            label="Last name"
            id="last-name"
            value={lastName}
            maxLength={200}
            onChange={onLastNameChanged}
          />
        </div>

        <div className="mt-12">
          <Button type="submit" className="niso-button" isDisabled={isInvalid}>
            Next
          </Button>
        </div>
      </form>
    </PageLayout>
  );
};

PassportNamePage.propTypes = {
  initialFirstName: PropTypes.string,
  initialLastName: PropTypes.string,
  dispatchAddPageData: PropTypes.func.isRequired,
  dispatchWizardNav: PropTypes.func.isRequired,
};

PassportNamePage.defaultProps = {
  initialFirstName: '',
  initialLastName: '',
};

export const mapStateToProps = state => ({
  initialFirstName: state.builder.ui.passportName.firstName,
  initialLastName: state.builder.ui.passportName.lastName,
});

export const mapDispatchToProps = {
  dispatchAddPageData: addPageData,
  dispatchWizardNav: navigateWizard,
};

export { PassportNamePage };

export default connect(mapStateToProps, mapDispatchToProps)(PassportNamePage);
